import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface LazyLoadingFallbackProps {
  message?: string;
}

/**
 * Loading fallback component for lazy-loaded routes.
 * Provides a consistent loading experience while chunks are downloaded.
 */
const LazyLoadingFallback: React.FC<LazyLoadingFallbackProps> = ({ 
  message = "Loading application..." 
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        gap: 2,
        padding: 3,
      }}
    >
      <CircularProgress 
        size={48} 
        sx={{ 
          color: theme.palette.primary.main,
        }} 
      />
      <Typography 
        variant="h6" 
        color="text.secondary"
        sx={{
          fontSize: '1.1rem',
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
      <Typography 
        variant="body2" 
        color="text.secondary"
        sx={{
          opacity: 0.7,
          fontSize: '0.9rem',
        }}
      >
        Downloading secure application components...
      </Typography>
    </Box>
  );
};

export default LazyLoadingFallback;

